"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowLoadingState = exports.getSetMailchimpSyncStatusRequestStatus = exports.getUpdateEspSyncRequestStatus = exports.getRemoveLastEspSyncErrorRequestStatus = exports.getFetchMailchimpSyncStatusRequestStatus = exports.getFetchEspSyncRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _constants = require("settings-ui-sdk/EspSync/constants");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _entitiesSelectors = require("settings-ui-modules/marketing/modules/esp-sync/selectors/entitiesSelectors");

var _actions = require("./actions");

var _reselect = require("reselect");

var getFetchEspSyncRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncActionType.FETCH_ESP_SYNC);
exports.getFetchEspSyncRequestStatus = getFetchEspSyncRequestStatus;
var getFetchMailchimpSyncStatusRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncActionType.FETCH_MAILCHIMP_SYNC_STATUS);
exports.getFetchMailchimpSyncStatusRequestStatus = getFetchMailchimpSyncStatusRequestStatus;
var getRemoveLastEspSyncErrorRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncActionType.REMOVE_LAST_ESP_SYNC_ERROR);
exports.getRemoveLastEspSyncErrorRequestStatus = getRemoveLastEspSyncErrorRequestStatus;
var getUpdateEspSyncRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncActionType.UPDATE_ESP_SYNC);
exports.getUpdateEspSyncRequestStatus = getUpdateEspSyncRequestStatus;
var getSetMailchimpSyncStatusRequestStatus = (0, _getRequestStatus.default)(_actions.EspSyncActionType.SET_MAILCHIMP_SYNC_STATUS);
exports.getSetMailchimpSyncStatusRequestStatus = getSetMailchimpSyncStatusRequestStatus;

var hasInitialEspStateLoaded = function hasInitialEspStateLoaded(state) {
  return (0, _entitiesSelectors.getEspSync)(state).get(_constants.ESP_CONNECTION_STATUS) !== null;
};

var shouldShowLoadingState = (0, _reselect.createSelector)([getFetchEspSyncRequestStatus, hasInitialEspStateLoaded], function (requestStatus, isInitialEspStateLoaded) {
  return isInitialEspStateLoaded ? _RequestStatusTypes.default.SUCCEEDED : requestStatus;
});
exports.shouldShowLoadingState = shouldShowLoadingState;